export default __webpack_public_path__ + "static/media/React-vue.105e368f.svg";